import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  activeLoadingProcess: [],
};

const loaderSlice = createSlice({
  name: 'loader',
  initialState,
  reducers: {
    setLoadingProcess(state, action) {
      state.activeLoadingProcess = action.payload;
    },
    startLoadingProcess(state, action) {
      // Add the process ID to the activeLoadingProcess array (avoid duplicates)
      if (!state.activeLoadingProcess.includes(action.payload)) {
        state.activeLoadingProcess.push(action.payload);
      }
    },
    endLoadingProcess(state, action) {
      // Remove the process ID from the activeLoadingProcess array
      state.activeLoadingProcess = state.activeLoadingProcess.filter(
        (process) => process !== action.payload
      );
    },
  },
});

export const { setLoadingProcess, startLoadingProcess, endLoadingProcess } =
  loaderSlice.actions;

export default loaderSlice.reducer;
